import { useMemo } from 'react'
import { useCruiseCheckoutStepLabels } from './steps/cruises'
import { useFlightsCheckoutStepLabels } from './steps/flights'
import { useHotelCheckoutStepLabels } from './steps/hotels'
import { useTourCheckoutStepLabels } from './steps/tours'

function useLocalizedCheckoutSteps(steps: Array<App.Checkout.CheckoutStep>): Array<App.Checkout.CheckoutStep> {
  const cruiseLabels = useCruiseCheckoutStepLabels()
  const flightsLabels = useFlightsCheckoutStepLabels()
  const hotelLabels = useHotelCheckoutStepLabels()
  const tourLabels = useTourCheckoutStepLabels()

  return useMemo(() => {
    const labelMap: Record<string, string> = {
      ...cruiseLabels,
      ...flightsLabels,
      ...hotelLabels,
      ...tourLabels,
    }

    return steps.map(step => ({
      ...step,
      label: labelMap[step.label] ?? step.label,
      subSteps: step.subSteps?.map(sub => ({
        ...sub,
        label: labelMap[sub.label] ?? sub.label,
      })),
    }))
  }, [steps, cruiseLabels, flightsLabels, hotelLabels, tourLabels])
}

export default useLocalizedCheckoutSteps
